<template>
  <div class="popup-box popup-set">
    <div class="setting-wrap bg-white popup">
      <button class="icon-close" @click="hideProfilePopup()" />
      <div class="popup-top">
        <a class="back" @click="changeViewType('main')"><i class="icon-arrow-left-lg" /></a>
        <h2 class="tx-center popup-tit">
          {{ $t('회원탈퇴') }}
        </h2>
      </div>
      <div>
        <h3 class="popup-heading">
          {{ $t('떠나는이유를알려주세요') }}
        </h3>
        <ul class="list-radio-select">
          <li>
            <label>
              <span>{{ $t('이용하고싶은서비스가없어요') }}</span>
              <input v-model="withdrawGb" type="radio" name="withdraw_gb" :value="100">
            </label>
          </li>
          <li>
            <label>
              <span>{{ $t('대체할만한서비스를찾았어요') }}</span>
              <input v-model="withdrawGb" type="radio" name="withdraw_gb" :value="101">
            </label>
          </li>
          <li>
            <label>
              <span>{{ $t('잦은오류가발생해요') }}</span>
              <input v-model="withdrawGb" type="radio" name="withdraw_gb" :value="102">
            </label>
          </li>
          <li>
            <label>
              <span>{{ $t('기타') }}</span>
              <input v-model="withdrawGb" type="radio" name="withdraw_gb" :value="103">
            </label>
            <div class="textarea-wrap">
              <textarea
                v-model="reason"
                :placeholder="$t('탈퇴이유를알려주시면서비스개선에도움이됩니다')"
                @input="hanldeInputChange"
              />
              <div class="txt-count">
                {{ reason.length }} / 200
              </div>
            </div>
          </li>
        </ul>
        <button
          class="single-btn btn-primary"
          @click="
            withdraw({
              withdrawGb,
              reason,
            })
          "
        >
          {{ $t('회원탈퇴하기') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const withdrawGb = ref(100)
const reason = ref('')

const { withdraw } = useAuth()

const { changeViewType, hideProfilePopup } = useProfile()

watch(reason, (val) => {
  if (val.length > 200) {
    reason.value = val.slice(0, 200)
  }
})

function hanldeInputChange(event: any) {
  if (reason.value.length > 200) {
    reason.value = reason.value.slice(0, 200)
  }
  else {
    reason.value = event.target.value
  }
}
</script>

<style scoped>
@import '~/assets/css/setting.css';
</style>
